import { DataContext } from 'contexts/DataContextContainer'
import InnerHTML from 'dangerously-set-html-content'
import { useContext, useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { DOCUMENT_LINKS } from 'services/constants'
import { DocumentContainer } from './style'

function Document({ docType }) {
  const { lang } = useContext(DataContext)
  const { t } = useTranslation()
  const [html, setHtml] = useState('')

  useEffect(() => {
    const renderContent = async () => {
      const result = await fetch(DOCUMENT_LINKS[docType][lang], {
        cache: 'default',
      })
      const _html = await result.text()
      setHtml(_html)
    }

    renderContent()
    document.title = t(`pg_title_${docType}`)
  }, [lang, docType, t])

  return (
    <DocumentContainer>
      <Container>
        <div className="content-wrapper" id="content-wrapper">
          {html && <InnerHTML html={html} />}
        </div>
      </Container>
    </DocumentContainer>
  )
}

export default Document
